import { type CampaignTypes, type CampaignSource, PRIZE_POP_CAMPAIGN_TYPE, TOURNAMENTS_CAMPAIGN_TYPE } from 'features/campaigns';

export class CampaignDataService {
  static getFirstCampaign(_campaignType: CampaignTypes, items?: CampaignSource[]): CampaignSource | null {
    if (!items || items.length === 0) {
      return null;
    }
    return items[0];
  }

  static isCampaignType(campaignType: CampaignTypes): boolean {
    return campaignType === PRIZE_POP_CAMPAIGN_TYPE;
  }

  static isTournamentType(campaignType: CampaignTypes): boolean {
    return campaignType === TOURNAMENTS_CAMPAIGN_TYPE;
  }

  static getCampaignData(data: CampaignSource): CampaignSource | null {
    if ('terms' in data && 'level' in data && 'joined' in data) {
      return data;
    }
    return null;
  }

  static getBasicData(data: CampaignSource) {
    return {
      id: data.id || '',
      name: data.name || '',
      resources: data.resources || {},
      prizeFund: data.prizeFund || 0,
      baseCurrency: data.baseCurrency || '',
      status: data.status,
    };
  }
}
